import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /** Move icons: square frames (true, default) or the shaped plates (round, cut-corner, studded, diamond, hexagon). */
    iconSquare: boolean;
  }
}

defineSetting({
  key: 'iconSquare',
  default: true,
  order: 345,
  menu: {
    group: 'visual',
    label: 'ไอคอนวิชาแบบสี่เหลี่ยม (ปิด = แบบเดิมตามประเภท)',
    note: () => 'มีผลเมื่อโหลดหน้าใหม่',
  },
});
